import { colors } from '@mehilainen/mds-tokens';
// NOTE: Do not import these from lib root (src/index)! Will cause circular deps
import { CalendarDay } from '../../../icons';
import { focusVisible } from '../shared';
const PICKER_DAY_SIZE = '36px';
export const ThemeDatepicker = {
    MuiDatePicker: {
        defaultProps: {
            // https://github.com/mui/mui-x/issues/5174#issuecomment-1153656551
            components: { OpenPickerIcon: CalendarDay },
            format: 'dd.MM.yyyy',
            views: ['day'],
            reduceAnimations: true,
            slotProps: {
                desktopPaper: {
                    sx: {
                        width: 'unset',
                        '& > * > *': {
                            width: 'unset !important',
                            maxHeight: 'unset !important',
                            padding: '8px 16px 16px',
                            '& [class*="MuiDayCalendar-weekDayLabel"]': {
                                width: '40px',
                                height: '40px',
                            },
                        },
                    },
                },
            },
        },
    },
    MuiCalendarPicker: {
        styleOverrides: {
            root: {
                width: 'unset',
                maxHeight: 'unset',
                '& [class*="MuiTypography-caption"]': {
                    width: PICKER_DAY_SIZE,
                    height: PICKER_DAY_SIZE,
                    margin: '4px',
                },
                '& > *': {
                    textTransform: 'capitalize',
                },
            },
        },
    },
    MuiPickersDay: {
        styleOverrides: {
            root: {
                width: PICKER_DAY_SIZE,
                height: PICKER_DAY_SIZE,
                margin: '4px',
                border: '1px solid',
                borderColor: colors.Primary500,
                borderRadius: '8px',
                backgroundColor: colors.White,
                '&:hover': {
                    backgroundColor: colors.White,
                },
                '&[class*="Mui-disabled"]': {
                    backgroundColor: colors.Gray100,
                    color: colors.Gray600,
                    border: 'unset',
                },
                '&[class*="MuiPickersDay-today"]': {
                    borderColor: colors.Gray300,
                },
                '&[class*="Mui-selected"]': {
                    overflow: 'hidden',
                    border: 'unset',
                    '&:after': {
                        content: '""',
                        width: 0,
                        height: 0,
                        borderStyle: 'solid',
                        borderWidth: '16px 0 0 16px',
                        borderColor: `transparent transparent transparent ${colors.Primary300}`,
                        left: 0,
                        bottom: 0,
                        position: 'absolute',
                    },
                },
                // NOTE: MUI specifically tells in the console to do this like this instead of using focusVisible property in styleOverrides
                '&[class*="Mui-focusVisible"]': Object.assign(Object.assign({}, focusVisible), { backgroundColor: 'unset', outlineOffset: '2px' }),
            },
            hiddenDaySpacingFiller: {
                border: 'unset',
            },
        },
    },
    // eslint-disable-next-line
};
